import api from 'api';

export const loadDimesnions = api('GET /api/smart-rules/resources/dimensions');
